export const WIKI_PUBLIC_URL = 'https://wiki.calamity.online/'
export const ARMORY_PUBLIC_URL = 'https://armory.calamity.online/'
export const PLAYER_HUB_URL = 'https://calamity.online/'
